import mapResponseToInvoice from '../mappers/mapResponseToInvoice'

export default async function(item: Response) {
  const json: IData = await item.json()

  return mapResponseToInvoice(json.items)
}

interface IData {
  messages: string[]
  items: IInvoiceData
}

export interface IInvoiceData {
  number: string
  link: string
  price: string
  price_gross: string
  currency: string
  buyer_name: string
  issue_date: string
}
